import i18next from 'i18next'
import { ToastsErrorBottomLeft } from './toastService'
import userManager from '../Oidc/userManager'
// import Const from 'Utils/Consts';

const { t } = i18next

const showResponseError = (error: any) => {
  const responseError = error.response

  let errors = []

  if (responseError?.status === 401) {
    userManager.removeUser()
    localStorage.clear()
    userManager.clearStaleState()
    userManager.signinRedirect({ state: { path: window.location.pathname }, prompt: 'login' })

    errors.push(t('LOGIN_ERROR_MESSAGE'))
  } else if (responseError?.status === 403) {
    errors.push(t('AUTHORIZATION_ERROR_MESSAGE'))
  } else if (responseError?.status === 400 && responseError?.data?.length) {
    if (typeof responseError.data == 'string') {
      errors.push(t(responseError.data))
    } else {
      responseError.data?.forEach((x: any) => {
        errors.push(t(x))
      })
    }
  } else {
    errors.push(t('OPERATION_ERROR_MESSAGE'))
  }

  ToastsErrorBottomLeft(errors)
}

export default showResponseError
